import apiClient from '@/services/apiClient';


/**
 * Obtiene todos los cupones
 */
export const getCoupons = async (params = {}) => {
  const token = localStorage.getItem('accessToken');
  const response = await apiClient.get(`/marketing/coupons/`, {
    headers: {
      Authorization: `Bearer ${token}`
    },
    params
  });
  // Manejar tanto el caso donde la respuesta es un objeto con 'results'
  // como el caso donde la respuesta es directamente una lista de cupones
  return response.data.results ? response.data.results : response.data;
};

/**
 * Obtiene un cupón por su ID
 */
export const getCoupon = async (id) => {
  const token = localStorage.getItem('accessToken');
  const response = await apiClient.get(`/marketing/coupons/${id}/`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data;
};

/**
 * Obtiene todos los usos de un cupón específico
 */
export const getCouponUsages = async (id) => {
  const token = localStorage.getItem('accessToken');
  const response = await apiClient.get(`/marketing/coupons/${id}/usages/`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data;
};

/**
 * Crea un nuevo cupón
 */
export const createCoupon = async (couponData) => {
  const token = localStorage.getItem('accessToken');
  const response = await apiClient.post(`/marketing/coupons/`, couponData, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data;
};

/**
 * Actualiza un cupón existente
 */
export const updateCoupon = async (id, couponData) => {
  const token = localStorage.getItem('accessToken');
  const response = await apiClient.put(`/marketing/coupons/${id}/`, couponData, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data;
};

/**
 * Elimina un cupón
 */
export const deleteCoupon = async (id) => {
  const token = localStorage.getItem('accessToken');
  await apiClient.delete(`/marketing/coupons/${id}/`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return true;
};

/**
 * Valida un código de cupón
 * @param {Object|string} data - Puede ser un string con el código o un objeto con {code, purchase_amount}
 * @returns {Promise<Object>} - Respuesta de la API
 */
export const validateCoupon = async (data) => {
  const token = localStorage.getItem('accessToken');
  let requestData;
  
  // Permitir tanto un string como un objeto
  if (typeof data === 'string') {
    requestData = { code: data };
  } else {
    requestData = data;
  }
  
  try {
    const response = await apiClient.post(`/marketing/coupons/validate/`, requestData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    throw error;
  }
};

/**
 * Aplica un cupón (incrementa su uso)
 */
export const applyCoupon = async (id, data = {}) => {
  const token = localStorage.getItem('accessToken');
  const response = await apiClient.post(`/marketing/coupons/${id}/apply/`, data, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data;
};

/**
 * Valida un código de cupón con productos específicos
 * @param {string} code - Código del cupón
 * @param {Array} products - Array de productos con {product_id, quantity}
 * @param {number} purchaseAmount - Monto total de la compra
 * @returns {Promise<Object>} - Respuesta de la API
 */
export const validateCouponWithProducts = async (code, products, purchaseAmount, email = '') => {
  const token = localStorage.getItem('accessToken');
  
  try {
    const response = await apiClient.post(`/marketing/coupons/validate/`, {
      code: code,
      purchase_amount: purchaseAmount,
      products: products,
      email: email
    }, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    throw error;
  }
};

export const getRouletteConfig = async () => {
  const response = await apiClient.get(`/marketing/roulette-prizes/public_config/`);
  return response.data;
};

export const spinRoulette = async (email) => {
  const response = await apiClient.post(`/marketing/roulette-prizes/spin/`, { email });
  return response.data;
};

export const getRoulettePrizes = async (params = {}) => {
  const token = localStorage.getItem('accessToken');
  const response = await apiClient.get(`/marketing/roulette-prizes/`, {
    headers: {
      Authorization: `Bearer ${token}`
    },
    params
  });
  return response.data.results ? response.data.results : response.data;
};

export const createRoulettePrize = async (data) => {
  const token = localStorage.getItem('accessToken');
  const response = await apiClient.post(`/marketing/roulette-prizes/`, data, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data;
};

export const updateRoulettePrize = async (id, data) => {
  const token = localStorage.getItem('accessToken');
  const response = await apiClient.put(`/marketing/roulette-prizes/${id}/`, data, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data;
};

export const deleteRoulettePrize = async (id) => {
  const token = localStorage.getItem('accessToken');
  await apiClient.delete(`/marketing/roulette-prizes/${id}/`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return true;
};
